export const CONTACT_MODAL_ACTIONS = Object.freeze({
  ADD: 'ADD',
  MANAGE: 'MANAGE'
});
export const CONTACT_MODAL_HEADING_LABEL = Object.freeze({
  ADD: 'Add new contact',
  MANAGE: 'Manage contact'
});
export const CONTACT_MODAL_BUTTON_TEXT = Object.freeze({
  ADD: 'Add contact',
  MANAGE: 'Save contact'
});
export const TEAM_MEMBER_MODAL_HEADING_LABEL = Object.freeze({
  ADD: 'Add team member',
  MANAGE: 'Manage team member'
});
export const TEAM_MEMBER_MODAL_BUTTON_TEXT = Object.freeze({
  ADD: 'Add team member',
  MANAGE: 'Save'
});
export const salesAndSupportRoleOption = {
  label: 'Sales support and approvals',
  value: 'salesSupportAndApprovals'
};
export const TEAM = 'Team';
export const CONTACT = 'Contacts';
export const TEAM_MEMBER = 'team member';
export const CONTACTS = 'contacts';
export const MANAGE_TEAM_MEMBER = 'Manage team member';
export const MANAGE_CONTACT = 'Manage contact';
export const DELETE_TEAM_MEMBER = 'Delete team member';
export const DELETE_CONTACT = 'Delete contact';